import stringSimilarity from "string-similarity";

export const competitionsIds = {
  // English Premier Division
  '5460221745907723457': '11',
  // League Championship
  '7152472061475853125': '12',
  // Bundesliga
  '4958049542603587684': '22',
  // 2. Bundesliga
  '2596045205534485282': '23',
  // Ligue 1 Uber Eats
  '8879186764835452557': '16',
  // Ligue 2
  '7872740013040629461': '17',
  // National fr
  '5287300672705851165': '18',
  // Serie A
  '3532311050828254831': '32',
  // Serie B
  '498099727728002338': '33',
  // Saudi Pro League
  '717166566538502822': '7920263',
  // MLS
  '7591007606768792946': '40',
  // Eliteserien
  '7847264274616601627': '1300397',
  // J League
  '8749335895005061972': '102428',
  // Tipico Bundesliga
  '8894757546900689923': '136543',
  // Eredivisie
  '1176248209038340764': '29',
  // Eerste Divisie (Pays-Bas)
  '770050243207196669': '30',
  // Primera División (Argentine)
  '5780980500354264558': '74',
  // Primera Uruguay
  '6687264387175430029': '5512770',
  // Primera División (Chili)
  '5973483605336888915': '5250792',
  // 'Primera División Costa Rica
  '6661860273197166506': '80000563',
  // liga MX
  '2517766011451984060': '135973',
  // Liga first division 
  '5180905787907624408': '67',
  // Liga Hypermotion
  '6449733130051411708': '68',
  // Chinese Super League
  '2865985881158334753': '130931',
  // Russian Premier League
  '7436238434413205902': '130486',
  // Belgian Pro League A
  '471877353908128115': '1',
  // Belgian Pro League B
  '7476796920092726568': '2',
  // superliga denmark
  '7436184736460225514': '6',
  // Scottish Premiership
  '3877156822269702699': '45',
  // Swedish Premier Division
  '8818660354873196777': '50',
  // Portuguese Premier League
  '3098726117681897732': '60',
  // Portuguese Second League
  '5765956105313483658': '61',
  // South korea first divivison
  '6596602463315595268': '136407',
  // South korea second division
  '7451439550848617605': '66029602'
};

export const countryIds = {
    "97272761295535086":"917510",
    "161211848947647670":"52",
    "204505849788814166":"390",
    "221995104739724777":"131012",
    "226747804364179447":"20",
    "233924291014656189":"757",
    "236892981072217755":"792",
    "374550180468752212":"918748",
    "384009410457327696":"118",
    "431135326776007441":"767",
    "480890112669170918":"376",
    "486987451502659995":"43",
    "594919586533661424":"780",
    "648054154293486319":"46",
    "720783681162034588":"770",
    "755688934270265174":"31",
    "814602845914704622":"775",
    "815136981655506477":"370",
    "815770271325179905":"1657",
    "835872569371171991":"12",
    "902650625574214200":"1444",
    "928374516372341881":"791",
    "964059173145583891":"388",
    "977144979315416648":"10",
    "1011295141255271868":"14",
    "1015299722394014952":"789",
    "1178433967428073401":"1440",
    "1191997016887167835":"22",
    "1227776224618780856":"1435",
    "1236749191409970637":"785",
    "1280867941109311402":"755",
    "1355412670948308185":"1438",
    "1359491422622546213":"137",
    "1369571193409855966":"54",
    "1384165339034441159":"55",
    "1526878550762535177":"377",
    "1619327355952142506":"796",
    "1699373751803443753":"8162661",
    "1778925932289277561":"364",
    "1853163864593441837":"383",
    "1855490462911877649":"129505",
    "2068142319623216833":"777",
    "2101957936161642317":"761",
    "2169975414829953188":"753",
    "2258952897626554629":"778",
    "2263016997530610884":"5",
    "2295642281255809818":"26",
    "2309774151865292311":"129504",
    "2342744156197028654":"129523",
    "2364823959799719221":"769",
    "2427482875388784235":"1442",
    "2431789722672520732":"5626837",
    "2499098327751657364":"143",
    "2567789945666047208":"8",
    "2584766072381216322":"142527",
    "2587864218099301171":"129514",
    "2596072475038309218":"35",
    "2604751169588524208":"762",
    "2604800527636462608":"142",
    "2616271072928950397":"381",
    "2647396378896795762":"122",
    "2669221641350349465":"768",
    "2681270293357396326":"119",
    "2683557543901320605":"6",
    "2698070941304673884":"34",
    "2702360275176045807":"214394",
    "2710594738475746845":"129526",
    "2748438781057575139":"788",
    "2765905020273391415":"361",
    "2774613839223906632":"50",
    "2797722948191029267":"917506",
    "2874984276628364218":"752",
    "2879773737204399236":"771",
    "2903812538056210460":"765",
    "2953884800103317955":"127",
    "2973972950017702676":"918745",
    "2974525142700938580":"779",
    "3005730696281861069":"129532",
    "3040098630121139071":"1658",
    "3076978179581882095":"13",
    "3080707510967347523":"113",
    "3128831383283860978":"363",
    "3209864783107147331":"37",
    "3244050176036924097":"41",
    "3263648072813126297":"23",
    "3325974787715451048":"36",
    "3436805196104999564":"917496",
    "3454223469995624469":"387",
    "3454998097981409262":"772",
    "3589579798907762059":"51",
    "3596499333356075736":"146",
    "3611014415459251903":"793",
    "3707168108139240252":"1441",
    "3773620120619408123":"1650",
    "3798233277220078690":"103277",
    "3840809281686295811":"790",
    "3844935109714541147":"214395",
    "3896113561825884545":"359",
    "3959899826160277776":"1652",
    "4074719200578824722":"373",
    "4106153748064600708":"773",
    "4140011618367964790":"47",
    "4140907395771624932":"29",
    "4144779594206522009":"145174",
    "4160292252983831910":"49",
    "4176919091926709712":"918740",
    "4179238157451594075":"108",
    "4225769452352149266":"1649",
    "4242437728770313839":"1651",
    "4286346590351396130":"1654",
    "4345098124014415124":"145",
    "4415375503585771493":"110",
    "4443261167493121814":"40",
    "4646239367614315039":"107",
    "4657844567229615949":"140",
    "4666695460191232886":"27",
    "4688350298689503812":"217945",
    "4709003352190021645":"134",
    "4712424037638052217":"21",
    "4743470262071128055":"33",
    "4876023260043932790":"763",
    "4907099188837101957":"797",
    "4996660799927731539":"782",
    "5012081299769530844":"758",
    "5032323043175626018":"112",
    "5083251217602276788":"794",
    "5089506400873583898":"754",
    "5098904279009624180":"123",
    "5147036378166156956":"106",
    "5170348962262191201":"62003815",
    "5245186417057113207":"1439",
    "5251283728038673796":"139",
    "5351469646426700101":"919586",
    "5357941485765650768":"1662",
    "5382339934393644876":"783",
    "5427766326705895690":"126",
    "5486543923201664952":"44",
    "5491729719948981181":"764",
    "5527764004396780907":"917502",
    "5528844973373215996":"787",
    "5563020457679980100":"129511",
    "5577763307217773591":"798",
    "5580454455704819324":"795",
    "5581194164501915313":"17",
    "5637161164860279268":"131",
    "5647726212746089737":"62002127",
    "5657513492811196803":"19",
    "5689892400008114827":"375",
    "5709982988563173339":"132",
    "5723153321395399229":"366",
    "5933632575216499002":"15",
    "5962215342198048784":"45",
    "6033022214207796658":"13113220",
    "6131803677262714586":"379",
    "6133847975636069640":"1655",
    "6305141938331256245":"133",
    "6338146479015383665":"23008660",
    "6358695447351483949":"760",
    "6384020915728591238":"1436",
    "6387639739096845357":"577",
    "6393506986913953684":"42",
    "6415182389159752632":"917498",
    "6457355436260974163":"121",
    "6516833552976503954":"756",
    "6538533966077836942":"374",
    "6603282320099431972":"125",
    "6643436964136830332":"766",
    "6654062256102571140":"117",
    "6723945663960692899":"786",
    "6773380740260711650":"144",
    "6781143541500508212":"82082540",
    "6945165534209327200":"129508",
    "6974176372034330900":"917508",
    "7004090426152546065":"39",
    "7069766016427477192":"759",
    "7088259328230243611":"120",
    "7109608409246551013":"24",
    "7153633514684547085":"141",
    "7235099381534123765":"776",
    "7238853058137227629":"1443",
    "7257908883496441652":"360",
    "7301390830792529428":"799",
    "7307137345513546480":"18",
    "7342277092392419585":"575",
    "7369310830252260275":"9",
    "7487328328468481038":"382",
    "7496344099104545250":"362",
    "7524387381348827710":"800",
    "7561268619999733483":"368",
    "7566498973141371877":"7",
    "7649796116644760768":"15064643",
    "7740429341063786413":"130",
    "7746025280824793964":"115",
    "7831573609501749832":"1653",
    "7840352056205032531":"801",
    "7887635410773019331":"30",
    "7896270835667686322":"13100103",
    "7926148827729882341":"129517",
    "7945499042070934356":"365",
    "7987321369576889822":"136",
    "8005668346906626012":"380",
    "8133627160883000730":"25",
    "8160228665957858988":"209002",
    "8216136283341515256":"11",
    "8221659069411660229":"367",
    "8278643184107909724":"371",
    "8288352734472802929":"38",
    "8364221315505677513":"114",
    "8413791920078762944":"774",
    "8486373697443593569":"28",
    "8550513668421028963":"784",
    "8558534262740863075":"16",
    "8578270289907544497":"1437",
    "8591918361352470644":"389",
    "8634133211507706020":"128",
    "8650364723504588801":"1656",
    "8673705892129822564":"109",
    "8818723077970107511":"32",
    "9021240568004069580":"48",
    "9027207784212051598":"116",
    "9102972967521838554":"129520",
    "9160725218854329612":"23088616",
    "9177909268103172368":"802",
    "5076692297737248676":"135"
    }
    

export const formatDate = (date) => {
  const dateObj = new Date(date);
  const day = dateObj.getDate();
  const month = dateObj.getMonth() + 1;
  const year = dateObj.getFullYear();
  return `${day}/${month}/${year}`;
};



export const calculateConfidenceScore = (sourceData, hitDocument, type, memberships ) => {
  if (type === 'team') {
    return calculateConfidenceScoreTeam(sourceData, hitDocument);
  } else {
    return calculateConfidenceScorePerson(sourceData, hitDocument, memberships);
  }
};

const calculateConfidenceScoreTeam = (teamResult, hitDocument) => {
    // get membership in 
  const nameScore = stringSimilarity.compareTwoStrings(teamResult.shortName, hitDocument.name);
  const countryScore = teamResult.country && hitDocument.nation
    ? stringSimilarity.compareTwoStrings(teamResult.country.name, hitDocument.nation.name)
    : 0;
  const divisionScore = teamResult.mainTournament && teamResult.mainTournament.competitionName && hitDocument.division
    ? compareCompetition(teamResult.mainTournament, hitDocument.division)
    : 0;

  const weightedScore = (nameScore * 0.5) + (countryScore * 0.3) + (divisionScore * 0.2);
  return {
    "score": Math.round(weightedScore * 100),
    "nameScore": nameScore,
    "countryScore": countryScore,
    "divisionScore": divisionScore
  }
};

const calculateConfidenceScorePerson = (personResult, hitDocument, memberships) => {
    // filter memberships with club.selection_id : true 
    memberships = memberships.filter(membership => membership.club.isSelection === false);
    console.log("memberships", memberships);
    // get membership with start date before 2022 october and end date after 2023 august
    const membership = memberships.find(membership => {
      const startDate = new Date(membership.startDate);
      const endDate = membership.endDate == null ? null : new Date(membership.endDate);
      const beforeMinStartDate = startDate < new Date('2023-09-01');
      const afterMaxEndDate =  endDate > new Date('2023-08-01');
      const notEnded = endDate == null;
      console.log("membership", membership);
      console.log("startDate", startDate);
      console.log("endDate", endDate);
      console.log("beforeMinStartDate", beforeMinStartDate);
      console.log("afterMaxEndDate", afterMaxEndDate);
      console.log("notEnded", notEnded);
      console.log("beforeMinStartDate && (!afterMaxEndDate || notEnded)", (!afterMaxEndDate || notEnded));
      return beforeMinStartDate && (afterMaxEndDate || notEnded);
    });

  const personName = personResult.usualName || personResult.fullName;
  const nameScore = stringSimilarity.compareTwoStrings(personName, hitDocument.name);

  const teamNationalityScore = membership && membership.club.country &&  hitDocument.nation
  ? compareNationality(membership.club.country, hitDocument.nation)
  : 0;
  const teamScore = membership && hitDocument.team
  ? stringSimilarity.compareTwoStrings(membership.club.name, hitDocument.team.name)
  : 0;
  console.log("teamNationalityScore", teamNationalityScore);
  console.log("teamScore", teamScore);
  console.log("nameScore", nameScore);
  const weightedScore = (nameScore * 0.5) + (teamNationalityScore * 0.3) + (teamScore * 0.2);

  return{
    "score": Math.round(weightedScore * 100),
    "nameScore": nameScore,
    "teamNationalityScore": teamNationalityScore,
    "teamScore": teamScore
  }
};
const compareNationality = (nationality1, nationality2) => {
    console.log("nationality1", nationality1);
    console.log("nationality2", nationality2);
  if(countryIds[nationality1.id.toString()] === nationality2.fm_id.toString()) {
    return 1;
  }
  return stringSimilarity.compareTwoStrings(nationality1.name, nationality2.name);
};
const compareCompetition = (mainTournament, division) => {
  if (competitionsIds[mainTournament.competitionId.toString()] === division.fm_id.toString()) {
    return 1;
  }
  return stringSimilarity.compareTwoStrings(mainTournament.competitionName, division.name);
};